import Command from '@ckeditor/ckeditor5-core/src/command';

var dataContent;
export default class NewsInTextCommand extends Command {
    execute() {
        console.log('Вызвали окно');
        const selectUrl  = prompt( 'Укажите ссылку на материал' );

        if(selectUrl === null || selectUrl === ''){
            return writer.createElement('paragraph');
        }
        axios.post('/getMetaParams', {
            url: selectUrl
        }).then(function (response){
            console.log('Получили данные');
            dataContent = response.data;
        });
        console.log('Запустили таймер');
        setTimeout(function (){
            editor_text.model.change(writer => {
                // Insert <simpleBox>*</simpleBox> at the current selection position
                // in a way that will result in creating a valid model structure.
                console.log('Создаем врезку');
                editor_text.model.insertContent(createNewsInText(writer));

            });
        },1000)

    }

    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'insertBox');

        this.isEnabled = allowedIn !== null;
    }
}

function createNewsInText(writer) {
    const NewsInTextBox = writer.createElement('insertBox', {'data-href': dataContent.url });
    const NewsInTextTitle = writer.createElement('insertTitle');
    const NewsInTextImage = writer.createElement('insertImage', {'src': dataContent.image });
    const NewsInTextText = writer.createElement('insertText');
    const innerTitle = writer.createText(dataContent.title);
    const innerText = writer.createText('В ТЕМУ');
    writer.append(innerTitle, NewsInTextTitle);
    writer.append(innerText, NewsInTextText);
    writer.append(NewsInTextTitle, NewsInTextBox);
    writer.append(NewsInTextImage, NewsInTextBox);
    writer.append(NewsInTextText, NewsInTextBox);

    return NewsInTextBox;
}
